import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function gerarProtocolo() {
  return 'EXCL-' + Math.random().toString(36).slice(2, 8).toUpperCase();
}

export default function DeletarDados() {
  const [email, setEmail]         = useState('');
  const [confirmed, setConfirmed] = useState(false);
  const [loading, setLoading]     = useState(false);
  const [protocolo, setProtocolo] = useState(null);

  const emailValido = emailRegex.test(email);
  const podeEnviar  = emailValido && confirmed && !loading;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!podeEnviar) return;
    setLoading(true);
    try {
      await fetch('https://videooferta.com/api/solicitar-exclusao.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
    } catch (_) {
      // exibe confirmação mesmo se o endpoint ainda não existir
    }
    setProtocolo(gerarProtocolo());
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#F7F6F2', padding: '52px 20px 80px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

      {/* barra superior */}
      <div style={{ width: '100%', maxWidth: 500, display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 36 }}>
        <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: '#6B6560' }}>
          VideoOferta
        </span>
        <Link to="/entrar" style={{ fontSize: 13, color: '#A8A29D', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 5 }}>
          ← Voltar ao login
        </Link>
      </div>

      {/* card */}
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: 'easeOut' }}
        style={{
          width: '100%', maxWidth: 500,
          background: '#fff', border: '1px solid #E8E5DF',
          borderRadius: 16, padding: '36px 36px 32px',
          boxShadow: '0 1px 3px rgba(0,0,0,.06), 0 4px 20px rgba(0,0,0,.04)',
        }}
      >
        <AnimatePresence mode="wait">

          {/* ── estado de sucesso ── */}
          {protocolo ? (
            <motion.div
              key="success"
              initial={{ opacity: 0, scale: 0.97 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{ textAlign: 'center', padding: '16px 0 8px' }}
            >
              <div style={{
                width: 56, height: 56, borderRadius: '50%',
                background: '#D1FAE5', color: '#065F46',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 20px', fontSize: 22,
              }}>✓</div>

              <h2 style={{ fontFamily: 'Georgia, serif', fontSize: 21, fontWeight: 'normal', marginBottom: 10 }}>
                Solicitação recebida
              </h2>
              <p style={{ fontSize: 14, color: '#6B6560', maxWidth: '34ch', margin: '0 auto 20px', lineHeight: 1.65 }}>
                Entraremos em contato no e-mail informado em até{' '}
                <strong>15 dias úteis</strong> com a confirmação da exclusão.
              </p>
              <div style={{
                display: 'inline-block',
                fontFamily: "'SF Mono', Consolas, monospace",
                fontSize: 12, background: '#F7F6F2', border: '1px solid #E8E5DF',
                padding: '7px 16px', borderRadius: 8, color: '#6B6560', letterSpacing: '.07em',
              }}>
                {protocolo}
              </div>
            </motion.div>

          ) : (

            /* ── formulário ── */
            <motion.div key="form" initial={{ opacity: 1 }} exit={{ opacity: 0 }}>

              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', color: '#B45309', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 7 }}>
                <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#B45309', flexShrink: 0, display: 'inline-block' }} />
                LGPD · Art. 18, inciso VI
              </div>

              <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 23, fontWeight: 'normal', lineHeight: 1.3, color: '#1A1815', marginBottom: 12 }}>
                Solicitação de exclusão de dados pessoais
              </h1>
              <p style={{ fontSize: 14, color: '#6B6560', lineHeight: 1.65, marginBottom: 24 }}>
                Como titular dos seus dados, você tem o direito de solicitar a exclusão
                permanente de todas as informações que a VideoOferta possui sobre você.
                Analisaremos sua solicitação e responderemos em até 15 dias úteis.
              </p>

              <hr style={{ border: 'none', borderTop: '1px solid #E8E5DF', margin: '0 0 22px' }} />

              {/* aviso amber */}
              <div style={{ background: '#FFFBEB', border: '1px solid #FDE68A', borderRadius: 8, padding: '15px 17px', marginBottom: 16 }}>
                <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.09em', textTransform: 'uppercase', color: '#B45309', marginBottom: 10 }}>
                  Dados que serão excluídos
                </div>
                <ul style={{ paddingLeft: 16, fontSize: 13.5, color: '#1A1815', lineHeight: 1.75 }}>
                  <li>Cadastro: nome, e-mail, telefone e senha</li>
                  <li>Vídeos e encartes criados na plataforma</li>
                  <li>Imagens, logotipos e arquivos de áudio enviados</li>
                  <li>Histórico de pagamentos e créditos adquiridos</li>
                  <li>Preferências, configurações e sessões ativas</li>
                </ul>
              </div>

              <p style={{ fontSize: 13, color: '#6B6560', paddingLeft: 14, borderLeft: '3px solid #E8E5DF', lineHeight: 1.65, marginBottom: 24 }}>
                Após a exclusão não será possível recuperar nenhum dado ou acessar
                a conta novamente. Créditos não utilizados não são reembolsáveis.
              </p>

              <form onSubmit={handleSubmit} noValidate>
                <div style={{ marginBottom: 16 }}>
                  <label htmlFor="del-email" style={{ display: 'block', fontSize: 11.5, fontWeight: 600, letterSpacing: '.06em', textTransform: 'uppercase', color: '#6B6560', marginBottom: 7 }}>
                    E-mail da conta
                  </label>
                  <input
                    id="del-email"
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="voce@exemplo.com"
                    autoComplete="email"
                    required
                    style={{
                      width: '100%', padding: '11px 13px',
                      border: `1px solid ${emailValido || !email ? '#E8E5DF' : '#FCA5A5'}`,
                      borderRadius: 8, background: '#F7F6F2',
                      color: '#1A1815', fontSize: 15, fontFamily: 'inherit', outline: 'none',
                    }}
                    onFocus={e => e.target.style.borderColor = '#B45309'}
                    onBlur={e => e.target.style.borderColor = emailValido || !email ? '#E8E5DF' : '#FCA5A5'}
                  />
                </div>

                {/* checkbox confirmação */}
                <label htmlFor="del-confirm" style={{
                  display: 'flex', gap: 11, alignItems: 'flex-start',
                  padding: '14px 15px', background: '#FEF2F2', border: '1px solid #FECACA',
                  borderRadius: 8, margin: '22px 0 18px', cursor: 'pointer',
                }}>
                  <input
                    id="del-confirm"
                    type="checkbox"
                    checked={confirmed}
                    onChange={e => setConfirmed(e.target.checked)}
                    style={{ width: 16, height: 16, flexShrink: 0, marginTop: 2, accentColor: '#DC2626', cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: 13, lineHeight: 1.55, color: '#1A1815', userSelect: 'none' }}>
                    Entendo que esta ação é <strong>permanente e irreversível</strong>.
                    Não haverá forma de recuperar meus dados ou créditos após a exclusão.
                  </span>
                </label>

                <button
                  type="submit"
                  disabled={!podeEnviar}
                  style={{
                    width: '100%', padding: 13,
                    background: podeEnviar ? '#DC2626' : '#DC2626',
                    color: '#fff', border: 'none', borderRadius: 8,
                    fontSize: 14.5, fontWeight: 600, fontFamily: 'inherit',
                    cursor: podeEnviar ? 'pointer' : 'not-allowed',
                    opacity: podeEnviar ? 1 : 0.4,
                    transition: 'opacity .15s, background .15s',
                    letterSpacing: '.015em',
                  }}
                >
                  {loading ? 'Enviando solicitação...' : 'Solicitar exclusão permanente'}
                </button>
              </form>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>

      {/* rodapé */}
      <p style={{ marginTop: 28, textAlign: 'center', fontSize: 12, color: '#A8A29D', lineHeight: 2 }}>
        VideoOferta &nbsp;·&nbsp;
        <Link to="/politica-de-privacidade" style={{ color: '#A8A29D' }}>Política de Privacidade</Link>
        &nbsp;·&nbsp;
        <a href="mailto:privacidade@videooferta.com" style={{ color: '#A8A29D' }}>privacidade@videooferta.com</a>
      </p>
    </div>
  );
}
